import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import { errorConditionGTM } from "../../../Utils/googleTags";
import ApiUrls from "../../../Utils/axr";

type appointmentPageContentInitialStateType = {
  appointmentPageContent: any;
  loading: boolean;
  error: any;
};
const initialState: appointmentPageContentInitialStateType = {
  appointmentPageContent: null,
  loading: false,
  error: null,
};
const host = window?.location?.host;
const file = "appointment-page.json";

export const getAppointmentPageContent = createAsyncThunk(
  "get/appointment-page/content",
  async () => {
    try {
      const response = await useFetchAemBrspdContents({
        [ApiUrls.aem_content]: `${file}?appName=${host}`,
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

const appointmentContentDetailSlice = createSlice({
  name: "appointment-page/Details",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAppointmentPageContent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAppointmentPageContent.fulfilled, (state, action) => {
      state.appointmentPageContent = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getAppointmentPageContent.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "Appointment content",
        action.error?.message,
        action?.type
      );
      state.appointmentPageContent = null;
      state.loading = false;
      state.error = action.error;
    });
  },
});

export default appointmentContentDetailSlice.reducer;
